export default __webpack_public_path__ + "static/media/method3.2ffa72ea.png";